<template>

  <div class="order-page-container">
    
    <template>
      <div style="background-color:#f5f5f5;  padding: 10px; ">
        <a-card :bordered="false" style="width: 100%;" id="title-card" >
          <template slot="title">
            <a-breadcrumb separator=">"> 
              <a-breadcrumb-item>
                <router-link to="/cliente/monitores/cotacoes">
                  Home
                </router-link>
              </a-breadcrumb-item>

              <a-breadcrumb-item class="order-page-title">
                Pedidos
              </a-breadcrumb-item>
            </a-breadcrumb>
          </template>
          <template slot="extra" >
            <template>
              <a-button type="default" @click="handleTotalizadores" style="margin-right: 4px;" :hidden="!isDesktop"> <i class="fa-solid fa-calculator"></i> {{showTotalizadores ? 'Ocultar Totalizadores': 'Mostrar Totalizadores'}} </a-button>
              <a-button type="danger" @click="handleLimparFiltros" style="margin-right: 4px;" :hidden="!isDesktop"> <i class="fa-solid fa-filter-circle-xmark"></i> Limpar Filtros </a-button>
              <a-button type="primary" @click="showDrawer" style="margin-right: 4px;"> <i class="fa-solid fa-filter"></i> Mais Filtros </a-button>
            </template>
            
          </template>
          <div class="order-page-info-containear">
            <template>

              <a-form layout="vertical" style="width: 100%" @submit.prevent="getListaPedidos">
                <a-row :gutter="8">

                  <!-- INPUTS -->                  

                  <a-col :xs="24" :s="12" :md="6" :lg="4" :xl="2">
                    <a-form-item label="N° do Pedido">
                      <a-input
                        v-model="buscaPedido"
                        @input="e => setOrderSearch(e.target.value)"
                        placeholder="Número/ID do Pedido"
                        @pressEnter="getListaPedidos"
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :s="12" :md="6" :lg="4" :xl="2">
                    <a-form-item label="N° da Cotação">
                      <a-input
                        v-model="buscaCotacao"
                        @input="e => setCotacao(e.target.value)"
                        placeholder="Número/ID da Cotação"
                        @pressEnter="getListaPedidos"
                      />
                    </a-form-item>
                  </a-col>

                  
                  <a-col :xs="24" :s="12" :md="12" :lg="4" :xl="2">
                    <a-form-item label="Status">
                      <a-select
                        :value="$store.state.selectedStatus"
                        :options="statusOptions"
                        placeholder="Selecione o status"
                        allowClear
                        @change="setStatus"
                        optionFilterProp="label"
                        :filterOption="filterOption"
                        mode="multiple"
                        :dropdown-style="{ minWidth: '200px' }"
                        class="fixed-height-select"
                      />
                    </a-form-item>
                  </a-col>

                  <!-- DATA PEDIDO -->
                  <a-col :xs="24" :s="12" :md="12" :lg="6" :xl="3">
                    <a-form-item label="Data de Criação">
                      <a-range-picker
                        v-model="rangeDate"
                        format="DD/MM/YYYY"
                        :locale="ptBR"
                        :ranges="ranges"
                        :placeholder="['Início', 'Fim']"
                      />
                    </a-form-item>
                  </a-col>

                  

                  <!-- DATA ENTREGA -->
                  <a-col :xs="24" :s="12" :md="12" :lg="6" :xl="3">
                    <a-form-item label="Data de Entrega">
                      <a-range-picker
                        v-model="rangeDelivery"
                        format="DD/MM/YYYY"
                        :locale="ptBR"
                        :ranges="ranges"
                        :placeholder="['Início', 'Fim']"
                      />
                    </a-form-item>
                  </a-col>

                  

                  <!-- SELECTS -->
                  <a-col :xs="24" :s="12" :md="10" :lg="6" :xl="3">
                    <a-form-item label="Empresa">
                      <a-select
                        :value="$store.state.selectedEmpresa"
                        show-search
                        :options="empresaOptions"
                        placeholder="Selecione a empresa"
                        allowClear
                        @change="setCompany"
                        optionFilterProp="label"
                        :filterOption="filterOption"
                        mode="multiple"
                        :dropdown-style="{ minWidth: '400px' }"
                        class="fixed-height-select"
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :s="12" :md="10" :lg="6" :xl="3">
                    <a-form-item label="Fornecedor">
                      <a-select
                        :value="$store.state.selectedFornecedor"
                        show-search
                        :options="fornecedorOptions"
                        placeholder="Selecione o fornecedor"
                        allowClear
                        @change="setSuplier"
                        optionFilterProp="label"
                        :filterOption="filterOption"
                        mode="multiple"
                        :dropdown-style="{ minWidth: '400px' }"
                        class="fixed-height-select"
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :s="12" :md="10" :lg="6" :xl="3">
                    <a-form-item label="Vendedor">
                      <a-select
                        :value="$store.state.selectedVendedor"
                        show-search
                        :options="vendedorOptions"
                        placeholder="Selecione o vendedor"
                        allowClear
                        @change="setVendedor"
                        optionFilterProp="label"
                        :filterOption="filterOption"
                        mode="multiple"
                        :dropdown-style="{ minWidth: '400px' }"
                        class="fixed-height-select"
                      />
                    </a-form-item>
                  </a-col>



                  <a-col flex="auto" class="actions-col">
                    <a-form-item label="‎" class="item-button">
                      <div class="actions-right">
                        <a-button
                          type="default"
                          icon="search"
                          @click="filtrarPedidos"
                        >
                          Filtrar
                        </a-button>
                        <div>
                          <AdvancedFiltersDrawer
                            :visible.sync="visible"
                            @apply="filtrarPedidos"
                            @clear="handleLimparFiltros"
                            @close="onClose"
                          >
                              <a-row :gutter="16">
                                <a-col :xs="24" :md="12">
                                  <a-form-item label="Nº do Pedido">
                                    <a-input
                                      v-model="buscaPedido"
                                      @input="e => setOrderSearch(e.target.value)"
                                    />
                                  </a-form-item>
                                </a-col>

                                <a-col :xs="24" :md="12">
                                  <a-form-item label="Nº da Cotação">
                                    <a-input
                                      v-model="buscaCotacao"
                                      @input="e => setCotacao(e.target.value)"
                                    />
                                  </a-form-item>
                                </a-col>
                          </a-row>

                          <a-row :gutter="16">
                              <a-col :xs="24" :md="12">
                                  <a-form-item label="Data de Criação">
                                    <a-range-picker
                                      v-model="rangeDate"
                                      format="DD/MM/YYYY"
                                      :locale="ptBR"
                                      :ranges="ranges"
                                      :placeholder="['Início', 'Fim']"
                                    />
                                  </a-form-item>
                              </a-col>

                              <a-col :xs="24" :md="12">
                                  <a-form-item label="Data de Confirmação">
                                    <a-range-picker
                                      v-model="rangeConfirmation"
                                      format="DD/MM/YYYY"
                                      :locale="ptBR"
                                      :ranges="ranges"
                                      :placeholder="['Início', 'Fim']"
                                    />
                                  </a-form-item>
                              </a-col>
                          </a-row>

                          <a-row :gutter="16">
                              <a-col :xs="24" :md="12">
                                <a-form-item label="Data de Entrega">
                                    <a-range-picker
                                        v-model="rangeDelivery"
                                        format="DD/MM/YYYY"
                                        :locale="ptBR"
                                        :ranges="ranges"
                                        :placeholder="['Início', 'Fim']"
                                    />
                                </a-form-item>
                              </a-col>

                              <a-col :xs="24" :md="12">
                                  <a-form-item label="Data de Recebimento">
                                      <a-range-picker
                                          v-model="rangeReceived"
                                          format="DD/MM/YYYY"
                                          :locale="ptBR"
                                          :ranges="ranges"
                                          :placeholder="['Início', 'Fim']"
                                      />
                                  </a-form-item>
                              </a-col>
                          </a-row>

                          <a-row :gutter="16">
                              <a-col :xs="24" :md="12">
                                  <a-form-item label="Empresa">
                                      <a-select
                                          :value="$store.state.selectedEmpresa"
                                          show-search
                                          :options="empresaOptions"
                                          placeholder="Selecione a empresa"
                                          allowClear
                                          @change="setCompany"
                                          optionFilterProp="label"
                                          :filterOption="filterOption"
                                          mode="multiple"
                                      />
                                  </a-form-item>
                              </a-col>

                              <a-col :xs="24" :md="12">
                                  <a-form-item label="Fornecedor">
                                      <a-select
                                          :value="$store.state.selectedFornecedor"
                                          show-search
                                          :options="fornecedorOptions"
                                          placeholder="Selecione o fornecedor"
                                          allowClear
                                          @change="setSuplier"
                                          optionFilterProp="label"
                                          :filterOption="filterOption"
                                          mode="multiple"
                                      />
                                  </a-form-item>
                              </a-col>
                          </a-row>

                          <a-row :gutter="16">
                              <a-col :xs="24" :md="12">
                                  <a-form-item label="Vendedor">
                                      <a-select
                                          :value="$store.state.selectedVendedor"
                                          show-search
                                          :options="vendedorOptions"
                                          placeholder="Selecione o vendedor"
                                          allowClear
                                          @change="setVendedor"
                                          optionFilterProp="label"
                                          :filterOption="filterOption"
                                          mode="multiple"
                                      />
                                  </a-form-item>
                              </a-col>
                          </a-row>

                          <a-row :gutter="16">
                              <a-col :xs="24" :md="12">
                                  <a-form-item label="Status">
                                      <a-select
                                          :value="$store.state.selectedStatus"
                                          :options="statusOptions"
                                          placeholder="Selecione o status"
                                          allowClear
                                          @change="setStatus"
                                          optionFilterProp="label"
                                          :filterOption="filterOption"
                                          mode="multiple"
                                      />
                                  </a-form-item>
                              </a-col>

                              <a-col :xs="24" :md="12">
                                  <a-form-item :label="$store.state.identifierText">
                                      <a-input
                                          v-model="identifier"
                                          @input="e => setIdentifier(e.target.value)"
                                      />
                                  </a-form-item>
                              </a-col>
                            </a-row>
                          </AdvancedFiltersDrawer>
                        </div>
                        
                      </div>
                    </a-form-item>
                  </a-col>

                </a-row>
              </a-form>
            
            </template>
          </div>
        </a-card>
      </div>
    </template>
    <template v-if="isDesktop" >
      <div style="background:#f5f5f5; padding: 0 10px 10px 10px">
        <dashboard-stats
          :items="dashboardCards"
          @click="aplicarFiltroRapido"
          :showTotalizadores="showTotalizadores"
        />
      </div>
    </template>
    
    <template>
      <div style="background:#f5f5f5; padding:0 10px 10px 10px; ">
        <a-card :bordered="false" style="width: 100%;" class="table-card" :style="selectedRowKeys.length && { marginBottom: '60px' }">
          <div class="table-container">
            <OrdersTable
              :data-source="arrayPedido"
              :loading="loading || exportingPdf"
              :printing="exportingPdf"
              :resyncing="resyncing"
              :notifying="notifying"
              :pagination="pagination"
              :row-selection="rowSelectionComputed"
              :can-cancel-order="canCancelOrder"
              :can-send-notification="canSendNotification"
              @change="handleTableChange"
              @print-selected="printClick"
              @cancel-selected="bulkCancelOrders"
              @resync-selected="bulkResyncOrders"
              @notify-selected="bulkNotifyOrders"
              @clear-selection="clearSelection"
            >
              <template slot="actions" slot-scope="{ record }">
                <ActionMenu :actions="getActions(record)" />
              </template>
            </OrdersTable>
          </div>
        </a-card>
      </div>
    </template>

    <a-modal
      v-model="ratingVisible"
      :footer="null"
      :maskClosable="false"
      :width="600"
      centered
    >
      <div class="text-center">
        <h4>
          Como foi sua experiência com
          <span>{{ indexArray }}</span>?
        </h4>

        <div class="d-flex justify-content-center my-3">
          <star-rating
            v-model="rating"
            @rating-selected="modalClick"
            :star-size="50"
            :show-rating="false"
          />
        </div>

        <h2 class="mt-3">{{ notaVendedor }}</h2>

        <h5 class="mt-4">
          Escolha um ou mais problemas que você encontrou:
        </h5>

        <a-checkbox-group v-model="checkbox">
          <div style="text-align: left;">
            <a-space direction="vertical" style="width: 100%">
              <a-checkbox
                v-for="item in arrayCheckbox"
                :key="item.id"
                :value="item.id"
              >
                {{ item.descricao }}
              </a-checkbox>
            </a-space>
          </div>
        </a-checkbox-group>

        <div class="mt-4">
          Sua avaliação é feita de forma anônima.
        </div>

        <a-button
          class="mt-3"
          type="primary"
          @click="postAvaliacaoPedido"
        >
          Enviar Feedback
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Button from "@/components/ui/buttons/Standard-Button.vue";
import ptBR from 'ant-design-vue/lib/date-picker/locale/pt_BR';
import moment from 'moment';
import 'moment/locale/pt-br';
import OrderService from "@/services/OrderService";
import V3OrderService from "@/services/v3/order.service";
import RequestService from "@/services/v3/request.service";
import OrderV3Service from "@/services/v3/requests/order.service";
import * as CONSTANTS from "@/constants/constants";
import DirectOrdersSubTab from "./_direct_orders.subtab";
import MobileNote from "@/components/notes/mobile-promotion.noteV2";
import StandardInputAuto from "@/components/ui/inputs/StandardInputAuto.vue";
import StandardInputListFiltered from "@/components/ui/inputs/StandardInputListFiltered.vue";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import QuotationService from "@/services/OrderService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import SellersService from "@/services/v2/sellers.service";
import Paginacao from "@/components/cliente/base-components/Pagination";
import { perm_mixin } from "@/mixins/permission.mixin";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import { mapState } from "vuex";
import StatsCards from "@/components/cliente/monitors/StatsCards.vue";
import ActionMenu from "../../../../components/popovers/action-menu.popover.vue";
import AdvancedFiltersDrawer from "../../../../components/cliente/monitors/AdvancedFiltersDrawer.vue";
import OrdersTable from "../../../../components/cliente/monitors/orders/OrdersTable.vue";

export default {
  mixins: [loaderMixin, perm_mixin],
  props: {
    request_id: {
      type: Number,
    },
  },
  components: {
    "cc-direct-orders-subtab": DirectOrdersSubTab,
    Button,
    MobileNote,
    StandardInputAuto,
    StandardInput,
    "cc-pagination": Paginacao,
    StandardInputListFiltered,
    'dashboard-stats': StatsCards,
    ActionMenu,
    AdvancedFiltersDrawer,
    OrdersTable
  },
  data() {
    return {
      showTotalizadores: true,
      isDesktop: window.innerWidth >= 720,
      visible: false,
      ratingVisible: false,
      moment,
      ptBR,
      page: 1,
      showPagination: false,
      orders: [],
      CONSTANTS: CONSTANTS,
      items_by_page_value: 50,
      service: new OrderService(),
      orderService: new QuotationService(),
      svc: new SellersService(),
      v3orderService: new V3OrderService(),
      req_svc: new RequestService(),
      dateInit: moment().subtract(30, "days").format("YYYY-MM-DD"),
      dateEnd: moment().add(1, "days").format("YYYY-MM-DD"),
      deliveryInit: null,
      deliveryEnd: null,
      showMobileFilter: false,
      selectPedidos: [],
      arrayPedido: [],
      lockStore: false,
      buscaPedido: null,
      arraySelectLoja: [],
      arraySelectFornecedor: [],
      arraySelectVendedor: [],
      selectedLoja: "",
      statuses: [
        { value: "P", text: "Pendente" },
        { value: "C", text: "Confirmado" },
        { value: "D", text: "Entregue" },
        { value: "ND", text: "Não Entregue" },
      ],
      identifier: "",
      isAllCheck: false,
      indexArray: "",
      indexIdPedido: null,
      rating: 0,
      checkbox: [],
      arrayCheckbox: null,
      notaVendedor: null,
      total_items: 1000,
      paginaAtual: 1,
      loading: true,
      exportingPdf: false,
      resyncing: false,
      notifying: false,
      isCancelling: false,
      openMenuIndex: null,
      selectedRowKeys: [],
      selectedMap: {},

      tableReady: false,
      rangeDate: [],
      rangeConfirmation: [],
      rangeDelivery: [],
      rangeReceived: [],
      ranges: {
        Hoje: [moment(), moment()],
        'Últimos 7 dias': [moment().subtract(7, "days"), moment()],
        'Últimos 30 dias': [moment().subtract(30, "days"), moment()],
        'Últimos 90 dias': [moment().subtract(90, "days"), moment()],
        'Esta Semana': [moment().startOf('week'), moment().endOf('week')],
        'Este Mês': [moment().startOf('month'), moment().endOf('month')],
        'Mês Passado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este Ano': [moment().startOf('year'), moment()],
        'Próximo Mês': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        locale: {
          items_per_page: '/ página'
        },
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
      },
      summary: {},
      status_recebido: null,
      filters: {}
    };
  },
  computed: {
    screenWidth(){
      return window.innerWidth;
    },
    selectedFornecedor() {
      return this.$store.state.selectedFornecedor;
    },
    selectedStatus(){
      return this.$store.state.selectedStatus;
    },
    selectedEmpresa(){
      return this.$store.state.selectedEmpresa;
    },
    selectedVendedor(){
      return this.$store.state.selectedVendedor;
    },
    buscaCotacao() {
      return this.$store.state.buscaCotacao;
    },
    ...mapState(["user"]),

    canCancelOrder() {
      const user = this.user || {};
      return !user.perms?.some(
        (perm) =>
          perm.resource === "REQUEST_ORDER" &&
          perm.action === "CANCEL" &&
          perm.subject_ids === null
      );
    },
    canSendNotification() {
      return this.can("ORDER", "SEND_NOTIFICATION");
    },
    selectedRows() {
      return Object.values(this.selectedMap)
    },
    rowSelectionComputed() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          selectedRows.forEach(row => this.$set(this.selectedMap, row.id, row))

          const keptKeys = selectedRowKeys.map(String)
          Object.keys(this.selectedMap).forEach(key => {
            if (!keptKeys.includes(key)) this.$delete(this.selectedMap, key)
          })
        },
      }
    },
    empresaOptions() {
      return this.arraySelectLoja.map(item => ({
        value: item.value?.loj_id,
        label: item.text || item.label || item.nome
      }))
    },
    fornecedorOptions() {
      return this.arraySelectFornecedor.map(item => ({
        value: item.value?.for_id,
        label: item.text || item.label || item.nome
      }))
    },
    vendedorOptions() {
      return this.arraySelectVendedor.map(item => ({
        value: item.id,
        label: item.name
      }))
    },
    statusOptions() {
      return this.mapOptions(this.statuses)
    },
    dashboardCards() {
      return [
        {
          key: 'pedidos',
          title: 'Pedidos',
          icon: 'orders',
          value: this.summary.total_pedidos,
          borderColor: '#1890ff',
        },
        {
          key: 'pendentes',
          title: 'Pendentes',
          icon: 'schedule',
          value: this.summary.pendentes,
          borderColor: '#faad14',
        },
        {
          key: 'confirmados',
          title: 'Em entrega',
          icon: 'local_shipping',
          value: this.summary.em_entrega,
          borderColor: '#722ed1',
        },
        {
          key: 'entregas_hoje',
          title: 'Entregas hoje',
          icon: 'delivery_truck_speed',
          value: this.summary.entregas_hoje,
          borderColor: '#13c2c2',
        },
        {
          key: 'atrasados',
          title: 'Atrasados',
          icon: 'traffic_jam',
          value: this.summary.atrasados,

          valueColor: '#fa8c16',
          borderColor: '#fa8c16',
        },
        {
          key: 'divergencia',
          title: 'Divergência',
          icon: 'check_circle_unread',
          value: this.summary.divergencia,

          valueColor: '#cf1322',
          borderColor: '#cf1322',
        },
        {
          key: 'valor_total',
          title: 'Valor Total (R$)',
          icon: 'paid',
          value: this.summary.valor_total,
          precision: 2,

          borderColor: '#0958d9',
        },
        {
          key: 'economia',
          title: 'Economia (R$)',
          icon: 'savings',
          value: this.summary.economia,
          precision: 2,

          valueColor: '#3f8600',
          borderColor: '#52c41a',
        },
      ];
    }
  },
  methods: {
    getActions(record, index) {
      return [
        {
          label: 'Confirmar Entrega',
          icon: 'inventory',
          iconClass: 'action-success',
          visible: record.status === 'C' && !record.status_recebido,
          onClick: () => this.confirm_delivery(record, index)
        },
        {
          label: 'Confirmar Pedido',
          icon: 'done',
          iconClass: 'action-success',
          visible: record.status === 'P' && !record.status_recebido,
          onClick: () => this.confirm_delivery_status_p(record, index)
        },
        {
          label: 'Informar Divergência',
          icon: 'warning',
          iconClass: 'action-warning',
          visible: !!record.status_recebido,
          onClick: () => this.sendToDivergency(record)
        },
        {
          label: 'Avaliar Vendedor',
          icon: 'star',
          iconClass: 'action-yellow',
          onClick: () => this.show(index)
        },
        {
          label: 'Reenviar notificação',
          icon: 'campaign',
          iconClass: 'action-warning',
          visible: this.can('ORDER', 'SEND_NOTIFICATION'),
          onClick: () => this.resend_notification(record.id)
        },
        {
          label: 'Falar com vendedor',
          icon: 'fab fa-whatsapp',
          iconClass: 'action-success',
          href: `https://api.whatsapp.com/send?phone=${record.usu_telefone}`,
          target: '_blank',
          visible: !!record.usu_telefone
        },
        {
          label: 'Exportar PDF',
          icon: 'picture_as_pdf',
          iconClass: 'action-danger',
          disabled: this.exportingPdf,
          loading: this.exportingPdf,
          onClick: () => this.print(record)
        },
        {
          label: 'Reenviar para o ERP',
          icon: 'sync',
          iconClass: 'action-primary',
          visible: record.vf_integration_status && record.vf_integration_status !== 'INTEGRATED',
          onClick: () => this.resyncOrder(record.id)
        },
        {
          label: 'Cancelar Pedido',
          icon: 'cancel',
          iconClass: 'action-danger',
          visible: this.canCancelOrder,
          onClick: () => this.cancelOrderButton(record)
        }
      ];
    },
    async handleTotalizadores(){
      if(!this.showTotalizadores) this.getSummary();
      this.showTotalizadores = !this.showTotalizadores;
    },
    buildParams(page = null) {
      return {
        page,
        page_size: page ? this.pagination.pageSize : null,

        "filter[idPedido]": this.buscaPedido || null,
        "filter[numerocotacao]": this.buscaCotacao || null,

        "filter[fornecedor]": this.selectedFornecedor ? this.selectedFornecedor .join(',')  : null,
        "filter[loja]": this.selectedEmpresa ? this.selectedEmpresa.join(',')  : null,
        "filter[vendedor]": this.selectedVendedor ? this.selectedVendedor.join(',')  : null,

        "filter[datainicial]":
          !this.buscaCotacao && this.rangeDate?.length
            ? this.rangeDate[0].format("YYYY-MM-DD")
            : null,

        "filter[datafinal]":
          !this.buscaCotacao && this.rangeDate?.length
            ? this.rangeDate[1].format("YYYY-MM-DD")
            : null,

        "filter[entregaInit]": this.rangeDelivery?.length
          ? this.rangeDelivery[0].format("YYYY-MM-DD")
          : null,

        "filter[entregaFinal]": this.rangeDelivery?.length
          ? this.rangeDelivery[1].format("YYYY-MM-DD")
          : null,

        "filter[status]": this.selectedStatus ? this.selectedStatus.join(',') : null,

        "filter[identifier]": this.identifier || null,

        "filter[produto]": this.selectedProduct || null,

        "filter[cnpj]": this.cnpj || null,

        "filter[cnpj_for]": this.cnpjFor || null,
        
        "filter[status_recebido]": this.status_recebido || null,

        ...this.filters
      }
    },
    async aplicarFiltroRapido(type) {
      this.limparFiltroRapido()
      this.limparFiltros()

      switch (type) {

        case 'pedidos':
          this.filters = {}
          break


        case 'pendentes':
          this.$store.state.selectedStatus = ['P']
          break


        case 'confirmados':
          this.$store.state.selectedStatus = ['C']
          this.status_recebido = 0
          break


        case 'entregues':
          this.$store.state.selectedStatus = ['C']
          this.status_recebido = 1
          this.filters['filter[divergencia]'] = 0
          break


        case 'divergencia':
          this.filters['filter[divergencia]'] = 1
          break

        case 'entregas_hoje':
          this.rangeDelivery = [
            this.$moment(),
            this.$moment()
          ]
          break


        case 'atrasados':
          this.filters['filter[atrasados]'] = 1
          break


        case 'valor_total':
          this.filters.only_stats = 0
          break
      }

      await this.getListaPedidos()
    },
    limparFiltroRapido() {
      this.filters = {}
    },
    cancelOrderButton(orderData) {
      if (this.canCancelOrder) {
        this.cancelOrder(orderData);
      } else {
        this.$toast.error("❌ Você não tem permissão para cancelar pedidos.");
      }
    },
    async cancelOrder(orderData) {
      try {
        this.isCancelling = true;

        const { value: motivoId, isConfirmed } = await this.$swal.fire({
          title: "Tem certeza que deseja cancelar este pedido?",
          icon: "warning",
          input: "select",
          inputOptions: {
            1: "Quantidade Errada",
            2: "Valores Divergentes",
            3: "Ruptura de Produtos",
            4: "Entrega não realizada",
            5: "Outros",
          },
          inputPlaceholder: "Selecione um motivo",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Sim, cancelar",
          cancelButtonText: "Não",
          inputValidator: (value) => {
            if (!value) {
              return "Você precisa escolher um motivo!";
            }
          },
        });

        if (!isConfirmed) return;

        await this.v3orderService.cancel(orderData.id, motivoId);

        if (this.$toast?.success) {
          this.$toast.success("✅ Pedido cancelado com sucesso!", {
            position: "top-right",
            duration: 3000,
          });
        } else {
          await this.$swal.fire({
            title: "Sucesso!",
            text: "Pedido cancelado com sucesso!",
            icon: "success",
            confirmButtonText: "OK",
          });
        }
        await this.reloadOrders?.();
      } catch (error) {
        if (this.$toast?.error) {
          this.$toast.error("❌ Falha ao cancelar pedido: " + error, {
            position: "top-right",
            duration: 3000,
          });
        } else {
          await this.$swal.fire({
            title: "Erro!",
            text: "Falha ao cancelar pedido" + error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } finally {
        this.isCancelling = false;
      }
    },
    clearSelection() {
      this.selectedRowKeys = [];
      this.selectedMap = {};
    },
    bulkCancelOrders() {
      if (!this.canCancelOrder) {
        this.$toast.error("❌ Você não tem permissão para cancelar pedidos.");
        return;
      }

      this.$swal
        .fire({
          title: `Cancelar ${this.selectedRows.length} pedido(s) selecionado(s)?`,
          icon: "warning",
          input: "select",
          inputOptions: {
            1: "Quantidade Errada",
            2: "Valores Divergentes",
            3: "Ruptura de Produtos",
            4: "Entrega não realizada",
            5: "Outros",
          },
          inputPlaceholder: "Selecione um motivo",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Sim, cancelar",
          cancelButtonText: "Não",
          inputValidator: (value) => {
            if (!value) return "Você precisa escolher um motivo!";
          },
        })
        .then(async ({ value: motivoId, isConfirmed }) => {
          if (!isConfirmed) return;

          const orderIds = this.selectedRows.map((orderData) => orderData.id);

          this.loading = true;
          try {
            const { data: result } = await this.v3orderService.cancelMany(orderIds, motivoId);
            const failed = result.failed?.length || 0;

            if (failed) {
              this.$swal.fire(
                "Atenção",
                `${result.cancelled.length} de ${orderIds.length} pedidos cancelados. ${failed} falharam.`,
                "warning"
              );
            } else {
              this.$swal.fire("Sucesso!", "Pedidos cancelados com sucesso!", "success");
            }
          } catch (error) {
            ErrorHandlerService.handle(error, this.$store);
          } finally {
            this.loading = false;
          }

          this.clearSelection();
          this.getListaPedidos(this.pagination.current);
        });
    },
    bulkResyncOrders() {
      if (!this.selectedRows.length) return;

      this.$swal
        .fire({
          title: `Reenviar ${this.selectedRows.length} pedido(s) para o ERP?`,
          text: "Esta operação irá enviar os pedidos selecionados novamente para a retaguarda.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, reenviar",
        })
        .then(async (resp) => {
          if (!resp.isConfirmed) return;

          const orderIds = this.selectedRows.map((orderData) => orderData.id);

          this.resyncing = true;
          try {
            await this.req_svc.resyncOrders(orderIds);
            this.$swal.fire("Sucesso!", "Pedidos reenviados para o ERP com sucesso!", "success");
            this.clearSelection();
            this.getListaPedidos(this.pagination.current);
          } catch (error) {
            ErrorHandlerService.handle(error, this.$store);
          } finally {
            this.resyncing = false;
          }
        });
    },
    bulkNotifyOrders() {
      if (!this.selectedRows.length) return;

      this.$swal
        .fire({
          title: `Reenviar notificação de ${this.selectedRows.length} pedido(s)?`,
          text: "Os vendedores serão novamente notificados sobre estes pedidos!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, reenviar",
        })
        .then(async (resp) => {
          if (!resp.isConfirmed) return;

          const orderIds = this.selectedRows.map((orderData) => orderData.id);

          this.notifying = true;
          try {
            const { data: result } = await this.v3orderService.notifyMany(orderIds);
            const failed = result.failed?.length || 0;

            if (failed) {
              this.$swal.fire(
                "Atenção",
                `${result.notified.length} de ${orderIds.length} notificações reenviadas. ${failed} falharam.`,
                "warning"
              );
            } else {
              this.$swal.fire("Sucesso!", "Notificações reenviadas com sucesso!", "success");
            }
            this.clearSelection();
          } catch (error) {
            ErrorHandlerService.handle(error, this.$store);
          } finally {
            this.notifying = false;
          }
        });
    },
    open_datepicker(idx) {
      document.getElementsByClassName("vdatetime-input")[idx].click();
    },
    checkAll(value) {
      this.arrayPedido.forEach((element) => (element.isCheck = value));
      this.isAllCheck = value;
    },
    setIdentifier(value) {
      this.identifier = value;
    },
    getSpecialBackground(index) {
      return ;
      if (index % 2 != 0) return "page-table-line-special";
      return "white-bg";
    },
    togleCheck(data) {
      data.isCheck = !data.isCheck;
      if (!data.isCheck) this.isAllCheck = false;
      this.$forceUpdate();
    },
    getDateTime(date) {
      if (date) {
        return moment(String(date)).format("DD/MM/YYYY HH:mm");
      } else {
        return "--";
      }
    },
    reloadOrders() {
      if (!this.loading) {
        this.loading = true;
        setTimeout(() => {
          this.getListaPedidos(this.pagination.current);
        }, 2000);
      }
    },
    setCotacao(text) {
      this.$store.commit("setBuscaCotacao", text);
    },
    setOrderSearch(text) {
      this.buscaPedido = text;
    },
    setCompany(value) {
      this.$store.commit("setSelectedEmpresa", value);
    },
    setSuplier(value) {
      this.$store.commit("setSelectedFornecedor", value);
    },
    setStatus(value) {
      this.$store.commit("setSelectedStatus", value);
    },
    setVendedor(value) {
      this.$store.commit("setSelectedVendedor", value);
    },
    getVendedores() {
      return this.v3orderService
        .sellers()
        .then((res) => res.data)
        .then((response) => {
          this.arraySelectVendedor = response.data || [];
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    getTotal(order) {
      return order.itens.reduce(
        (x, { preco_embalagem, quantidade }) => x + preco_embalagem * quantidade,
        0
      );
    },
    translateStatus(status) {
      switch (status) {
        case "AGUARDANDO_CONFIRMACAO":
          return "AGUARDANDO CONFIRMACAO";
        case "CONFIRMADO":
          return "CONFIRMADO";
        default:
          return "Não identificado!";
      }
    },
    paginate() {
      this.page = this.page + 1;
      this.getDirectSaleOrders();
    },
    confirm_delivery(order, index) {
      this.confirm_action({
        message: "Confirma recebimento do pedido?",
        deny_text: "Com divergência!",
        cancel_buttom_color: "#4D4F5C",
        callback: (result) => {
          this.svc.confirm_delivery(order.id).then((res) => {
            order.status_recebido = true;
            this.reloadOrders();
          });
        },
        deny_callback: () => {
          this.svc.confirm_delivery(order.id);
          this.$router.push({
            name: "cliente-monitores-divergent",
            params: {
              id: order.quotation_id,
              sellerid: order.seller_id,
              sid: order.store.id,
              providerid: order.provider.id,
            },
          });
        },
      });
    },
    sendToDivergency(order) {
      this.$router.push({
        name: "cliente-monitores-divergent",
        params: {
          id: order.quotation_id,
          sellerid: order.seller_id,
          sid: order.store.id,
          providerid: order.provider.id,
        },
      });
    },
    confirm_delivery_status_p(order) {
      this.confirm_action({
        message: "Confirma recebimento do pedido?",
        cancel_buttom_color: "#4D4F5C",
        callback: (result) => {
          this.svc.confirm_delivery_status_p(order.id).then((res) => {
            order.status_recebido = true;
            this.reloadOrders();
          });
        },
      });
    },
    updatePage(new_page) {
      this.getListaPedidos(new_page);
    },
    postAvaliacaoPedido() {
      let arrayCheck = [];
      this.checkbox.forEach((data, index) => {
        if (data) {
          arrayCheck.push(this.arrayCheckbox[index].id);
        }
      });
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      axios
        .post(
          `${CONSTANTS.API_URL}/atualizaravaliacaopedido`,
          {
            id_pedido: this.indexIdPedido,
            nota: this.rating,
            comentarios: arrayCheck,
            observacao: " ",
          },
          config
        )
        .then(() => {
          this.hide();
          this.getListaPedidos(this.pagination.current);
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    hide() {
      this.$modal.hide("hello-world");
      this.rating = 0;
      this.select = "";
      this.checkbox = [];
    },
    modalClick() {
      if (this.rating === 1) {
        this.notaVendedor = "Vendedor péssimo, poderia melhorar.";
      }
      if (this.rating === 2) {
        this.notaVendedor = "Vendedor ruim, poderia melhorar.";
      }
      if (this.rating === 3) {
        this.notaVendedor = "Vendendor regular, poderia melhorar.";
      }
      if (this.rating === 4) {
        this.notaVendedor = "Vendedor bom, mas poderia melhorar.";
      }
      if (this.rating === 5) {
        this.notaVendedor = "Vendedor Excelente!";
      }
    },
    show(pedido) {
      this.indexArray = pedido.seller.name;
      this.indexIdPedido = pedido.id;
      this.rating = pedido.rating.score;

      this.checkbox = (pedido.rating.comentarios || []).map(c => c.id);

      this.ratingVisible = true;
    },

    hide() {
      this.ratingVisible = false;
    },
    getArrayPedido() {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      axios
        .get(`${CONSTANTS.API_URL}/listarcomentariospedido`, config)
        .then((data) => {
          this.arrayCheckbox = data.data.comentarios;
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    getDirectSaleOrders() {
      // this.is_loading = true;
      // this.service.getDirectSaleOrders({ page: this.page, page_size: this.items_by_page_value })
      // .then(response => response.data)
      // .then(data => {
      //     this.is_loading = false;
      //     this.orders = this.orders.concat(data.data);
      //     this.showPagination = data.next_page_url != null;
      // }).catch(error => {
      //     this.is_loading = false;
      //     ErrorHandlerService.handle(error, this.$store);
      // });;
    },
    print(order) {
      this.exportOrdersPdf([order.id]);
    },
    exportOrdersPdf(ids, collapsePages = false) {
      this.exportingPdf = true;

      return this.v3orderService
        .export_pdf(ids, collapsePages)
        .then((response) => response.data)
        .then((data) => {
          const file = new Blob([data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          setTimeout(() => URL.revokeObjectURL(fileURL), 60000);
          return true;
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
          return false;
        })
        .finally(() => {
          this.exportingPdf = false;
        });
    },
    isChecked(){
      let check = false;
      this.arrayPedido.forEach((element) => {
        if (element.isCheck) check = true;
      });
      return check;
    },
    printClick() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length === 0) {
        this.$swal.fire("Por Favor,", "Selecione ao menos uma cotação.");
        return;
      }

      this.selectPedidos = this.selectedRows;
      const ids = this.selectPedidos.map((item) => item.id);

      this.$swal
        .fire({
          icon: "info",
          title: "Deseja juntar as paginas?",
          text: "Deseja que as informações sejam agrupados no menor numero de paginas posiveis?",
          iconHtml: '<span class="material-icons-outlined print-icon" style="font-size: 1rem">print</span>',
          showDenyButton: true,
          denyButtonText: "Não",
          denyButtonColor: "red",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Sim",
        })
        .then((resp) => {
          if (resp.isConfirmed || resp.isDenied) return this.exportOrdersPdf(ids, resp.isConfirmed);
        })
        .then((exported) => {
          if (exported) this.clearSelection();
        });
    },
    getLojas() {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      return axios
        .get(`${CONSTANTS.API_URL}/getrequisitantescliente`, config)
        .then((data) => {
          data.data.requisitantes.forEach((element) => {
            this.arraySelectLoja.push({
              text: element.loj_nomeFantasia,
              value: element,
            });
          });
          if (
            !this.can("REQUEST_ORDER", "READ_ALL") ||
            JSON.parse(localStorage.getItem("store_id"))
          ) {
            this.selectedLoja = this.arraySelectLoja[0].value;
            this.lockStore = true;
          }
          this.pagination.current = 1;
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    getListaPedidos(page = 1) {
      this.loading = true;
      this.visible = false;
      const params = this.buildParams(page);
      if(this.showTotalizadores) this.getSummary();
      this.v3orderService
        .query(params)
        .then((res) => {
          this.loading = false;

          const response = res.data;

          this.arrayPedido = response.data;

          this.pagination.total = response.meta.total;
          this.pagination.current = response.meta.current_page;
          this.pagination.pageSize = response.meta.per_page;
        })
        .catch((error) => {
          this.loading = false;
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    getFornecedor() {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      axios
        .get(`${CONSTANTS.API_URL}/getfornecedorescliente`, config)
        .then((data) => {
          data.data.fornecedores.forEach((element) => {
            this.arraySelectFornecedor.push({
              text: element.for_nome,
              value: element,
            });
          });
          this.getLojas();
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    resend_notification(order_id) {
      this.confirm_action({
        message: "Confirma envio de notificação?",
        subtitle: "O vendedor será novamente notificado sobre este pedido!",
        callback: () => {
          this.v3orderService
            .notifyMany([order_id])
            .then(({ data }) => {
              if (!data.notified.length) {
                this.present_error("Não foi possível reenviar a notificação deste pedido.");
                return;
              }
              this.present_info("Notificação reenviada com sucesso!");
            })
            .catch((error) => {
              ErrorHandlerService.handle(error, this.$store);
            });
        },
      });
    },
    edit_product(seller, current) {
      if (seller.edi_children) {
        let di = seller.edi_children.find((d) => d.status == "FAILED");
        if (di) {
          this.prod_svc.load(di.data_id).then((response) => {
            this.product = response.data;
            this.current_seller = current;
          });
        }
      }
    },
    filtrarPedidos(){
      this.pagination.current = 1;
      this.limparFiltroRapido();
      this.getListaPedidos(1);
    },
    toggleMenu(index) {
      this.openMenuIndex =
        this.openMenuIndex === index ? null : index
    },
    toggleTotalizadores() {
      this.showTotalizadores = !this.showTotalizadores
    },
    closeMenu() {
      this.openMenuIndex = null;
    },
    handleClickOutside(e) {
      if (!e.target.closest('.actions-container')) {
        this.openMenuIndex = null
      }
    },
    resyncOrder(id_pedido) {
      this.$swal
        .fire({
          title: "Deseja sincronizar novamente este pedido?",
          text: "Esta operação ira enviar o pedido novamente para a retaguarda.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, sincronizar novamente.",
        })
        .then((resp) => {
          if (!resp.isConfirmed) return;
          this.present_loader("Ressincronizando...");
          this.req_svc.resyncOrder(id_pedido).then((resp2) => {
            this.dismiss_loader();
            this.reloadOrders();
          });
        });
    },
    toggleCheck(record) {
      record.isCheck = !record.isCheck;
    },
    mapOptions(list) {
      if (!Array.isArray(list)) return []
      return list.map(item => ({
        value: item.value?.loj_id || item.id || item.value,
        label: item.text || item.label || item.nome
      }))
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getListaPedidos(pagination.current);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    limparFiltros() {
      this.buscaPedido = null
      this.setCotacao(null)
      this.setSuplier(null)
      this.setCompany(null)
      this.rangeDate = null
      this.rangeConfirmation = null
      this.rangeDelivery = null
      this.rangeReceived = null
      this.setStatus(null)
      this.setVendedor(null)
      this.setIdentifier(null)
      this.$store.state.selectedFornecedor = []
      this.$store.state.selectedEmpresa = []
      this.$store.state.selectedStatus = []
      this.$store.state.selectedVendedor = []
      this.filters = {}
    },
    handleLimparFiltros(){
      this.limparFiltros()
      this.getListaPedidos(1)
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 720
      this.$nextTick(() => {
          setTimeout(() => {
            const tableBody = this.$el.querySelector('.ant-table-body')
            if (tableBody) {
              tableBody.scrollLeft = 0
            }
          }, 100)
        })
    },
    async getSummary(){
      const params = this.buildParams();

      this.v3orderService
        .summary(params)
        .then((res)=>{
          const response = res.data;
          this.summary = response;
        }
      )
    }
  },
  watch: {
    items_by_page_value: function () {
      this.orders = [];
      this.getDirectSaleOrders();
    },
  },
  mounted() {
    // this.v3orderService.get_orders();
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
    moment.locale('pt-br')
    // let sidebar = document.getElementsByClassName('client-sidebar')[0];
    // let header = document.getElementsByClassName('desktop-header')[0];
    // sidebar.classList.add('re-zoom');
    // header.classList.add('re-zoom');
    document.body.classList.add('no-zoom');
    this.getFornecedor();
    this.getVendedores();
    this.getListaPedidos(1);
    document.addEventListener('click', this.closeMenu);
    document.addEventListener('click', this.handleClickOutside)
    if (this.request_id) this.$store.commit("setBuscaCotacao", this.request_id);
    this.getArrayPedido();
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
    // let sidebar = document.getElementsByClassName('client-sidebar')[0];
    // let header = document.getElementsByClassName('desktop-header')[0];
    // sidebar.classList.remove('re-zoom');
    // header.classList.remove('re-zoom');
    document.body.classList.remove('no-zoom');
    document.removeEventListener('click', this.closeMenu);
    document.removeEventListener('click', this.handleClickOutside)
  }
};
</script>

<style lang="scss">
@import "@/sass/commons/_variables";
.fixed-height-select.ant-select,
.fixed-height-select .ant-select-selection--multiple {
    min-height: 32px !important;
    max-height: 32px !important;
    overflow: auto;
}
.order-page-container {
  font-size: 1rem;
}
.page-route-select {
    display: flex;
    align-items: center;
}
.page-route-select-text {
    font-weight: 400;
    font-size: 1.36em;
    color: #ababab;
    margin-right: 20px;
    cursor: pointer;
}
.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}
.order-page-print-button {
    width: 12%;
}
.order-page-title {
  font-weight: 500;
  font-size: 1.5rem;
  letter-spacing: 0.15px;
  color: #605f5f;
}
.page-table-line-special {
    background: #f7f7f7;
}
.order-page-info-containear {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  // margin-top: 1vh;
}
.order-page-filter-container {
    display: flex;
    margin-top: 2vh;
    align-items: flex-end;
}
.order-page-table-header {
  margin-top: 4vh;
  background: #fffefc;
  border: 0.5px solid #e5e5e5;
  font-weight: 600;
  font-size: 1rem;
  color: #605f5f;
  padding: 0.7vh 0;
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
}
.order-table .checkbox-width {
    text-align: center;
    color: var(--primary-color);
    cursor: pointer;
}

.id-width {
    width: 10%;
    text-align: center;
}
.store-width {
    width: 14%;
    text-align: center;
    padding: 0 0.5%;
}
.date-width {
    width: 9%;
    text-align: center;
}
.price-width {
    width: 7%;
    text-align: center;
}
.seller-width {
    flex: 1;
    text-align: center;
}
.value-width {
    white-space: nowrap;
}
.status-width {
    width: 7%;
    text-align: center;
}
.confirmationdate-width {
    width: 11%;
    text-align: center;
}
.confirmationdate-header-text {
    font-size: 0.8em;
}
.suplier-width {
    width: 14%;
    text-align: center;
}
.review-width {
    width: 7%;
    text-align: center;
}
.actions-width {
    position: sticky;
    right: 0;
    z-index: 3;
    background: #fff;
}
.page-filters__right-wrapper {
    width: 25vw;
}
.page-filters__right-title-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 1rem;
}
.page-filters__right-title {
    font-weight: 400;
    font-size: 1.7em;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #898989;
}
.page-filters__right-select-wrapper {
    display: flex;
    align-items: center;
}
.date-icon {
    background-color: var(--primary-color);
    color: #fff;
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 0px 8px 8px 0px;
    position: relative;
    left: -6px;
}
.order-print-check {
    position: absolute;
    background-color: white;
    top: 45%;
    left: 35%;
    width: 35%;
    height: 20%;
    border: 1px solid var(--primary-color);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.order-print-button {
    width: 7vw;
    border-radius: 10px;
    height: 5vh;
}
.order-print-button-yes {
    background-color: lightgreen;
    color: white;
    margin-right: 3vw;
}
.order-print-button-no {
    background-color: lightcoral;
    color: white;
}
.order-table-seller-content {
    text-align: left;
    padding-left: 5%;
}
.order-table-store-content {
    text-align: left;
}
.order-page-table {
  display: flex;
  font-weight: 300;
  font-size: 1rem;
  color: #605f5f;
  align-items: center;
  padding: 2vh 0;
}
.order-page-table-separator {
    border-right: 0.5px solid #dde5e9;
}
.order-page-filter-section1 {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 1.5vh;
}
.selected-options-containear {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    column-gap: 1.5vw;
    min-height: 7vh;
}
.selected-option {
    background: #fcf9f7;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1vh 5%;
    font-weight: 300;
    font-size: 11px;
    letter-spacing: 0.15px;
    color: var(--primary-color);
    margin-top: 1vh;
}
.order-page-filter-section2 {
    display: flex;
    flex: 1;
    justify-content: space-between;
}
.tablet {
    display: none;
}
.mobile {
    display: none;
}
.order-table-mobile-header {
    display: none;
}
.notification-icon {
    color: var(--primary-color);
    cursor: pointer;
    font-size: 1.5em;
}
.whatsapp-tick {
    cursor: default;
    color: gray;
}
.whatsapp-read {
    cursor: default;
    color: blue;
}
.whatsapp-error {
    cursor: default;
    color: #cd2a2a;
}
.integration-pending {
    cursor: default;
    color: orange;
}

::v-deep(.input-containear) {
    height: 4.5vh !important;
}
.print-button {
    height: 6vh;
}
.filter-button {
    height: 6vh;
}
.status-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  text-wrap: nowrap;
}

.status-text {
    font-size: 0.85em;
    font-weight: 500;
}

.whatsapp-tick {
    color: gray;
}

.whatsapp-read {
    color: blue;
}

.error {
    color: #cd2a2a;
}

.integration-ok {
    color: #4caf50;
}

.warning {
    color: orange;
}

.material-icons,
.fas {
    font-size: 1.3rem;
}
.order-table {
    width: 100%;
    border-collapse: collapse;
}

.order-table th,
.order-table td {
    border-bottom: 1px solid #ddd;
    text-align: left;
}

.order-table th {
    background: #f5f5f5;
    text-align: center;
}

th {
  font-size: 0.8rem;
}

.value-badge {
  background: green;
  color: white;
  padding: 4px 10px;
  border-radius: 10px;
  opacity: 0.7;
  overflow: hidden;
  white-space: nowrap;
  word-break: keep-all;
}
.negative-badge {
  background: red;
  color: white;
  padding: 4px 10px;
  border-radius: 10px;
  opacity: 0.7;
  overflow: hidden;
  white-space: nowrap;
  word-break: keep-all;
}
.buttons {
    justify-content: flex-end;
    display: flex;
    flex-direction: row;
    padding: 5px;
    gap: 10px;
    left: auto;
}
.status-pending {
    color: orange;
}
.preorder-zap-hover {
    color: #4ac959;
}
.preorder-zap-link {
  font-size: 0.7rem;
}
.preorder-zap-container {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 0.9em;
    color: #605f5f;
}

.dropdown-item:hover {
    background: #f7f7f7;
}

.dropdown-item span {
    font-size: 1.5em;
}

.dropdown-item.danger {
    color: #ff0000;
}

.success {
  color: #30aa4c;
}

.star {
    color: #ffca2b;
}

.pdf {
    color: #cd2a2a;
}

.table-container {
  width: 100%;
  overflow-y: scroll;
  max-height: calc(78vh - 74px);
}

.ant-table-tbody > tr > td {
  overflow: visible !important;
  font-size: 0.7rem;
  // padding: 10px 0 !important;
}
.ant-table-tbody > tr > td.ant-table-row-cell-break-word {
  padding-left: 2px !important;
}

.ant-table-row-cell-break-word{
  padding: 0 0;
}

.ant-table-wrapper {
  width: 100%;
}

.actions-container {
  position: relative;
  display: flex;
  justify-content: center;
}

.money-cell {
  white-space: nowrap;
  word-break: keep-all;
}

body.no-zoom {
  zoom: 1 !important;
}

.re-zoom {
  zoom: 80% !important;
  overflow: hidden !important;
}

.ant-form-item {
  display: block;
  width: 100%;
  margin-bottom: 2px !important;
}

.ant-form-item-label {
  padding-bottom: 2px !important;
}

.actions-col {
  display: flex;
  align-items: flex-end;
}

.actions-right {
  margin-left: auto;
  display: flex;
  gap: 8px;
  margin-left: auto;
  justify-content: flex-end;
}

.item-button{
  vertical-align: bottom;
}

.cell {
  display: flex;
  flex-direction: column;
  justify-content: center;  
}

.page-body-y {
  min-height: 100vh;
}

.page-body-x {
  // margin-left: 0;
}
.ant-calendar-range-picker {
  display: flex;
  align-items: center;
  width: 100%;
  white-space: nowrap;
}

.ant-calendar-range-picker-input {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
}

.ant-calendar-picker{
  white-space: nowrap;
}

.ant-calendar-range-picker-separator {
  padding: 0 8px;
  white-space: nowrap;
}

.ant-calendar-range-picker-input {
  display: inline-block !important;
  white-space: nowrap;
}



.ant-table-tbody > tr:nth-child(odd) > td,
.ant-table-fixed-left .ant-table-tbody > tr:nth-child(odd) > td,
.ant-table-fixed-right .ant-table-tbody > tr:nth-child(odd) > td {
  background-color: #ffffff;

}

.ant-table-tbody > tr:nth-child(even) > td,
.ant-table-fixed-left .ant-table-tbody > tr:nth-child(even) > td,
.ant-table-fixed-right .ant-table-tbody > tr:nth-child(even) > td {
  background-color: #fafafa;

}
.anticon{
  vertical-align: 0 !important;
}

.ant-calendar-range-picker-input, .ant-select-selection__placeholder{
  font-size: 0.8rem;
}

.table-card > .ant-card-body {
  padding: 0px !important;
}
.fa-solid {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  margin-right: 10px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}
.statistic-icon{
  font-size: 1rem;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

@media (max-width: 720px) {
  /* Stack table elements */
  .ant-table-scroll > .ant-table-body > table > thead , .ant-table-fixed-left, .ant-table-fixed-right, #title-card > .ant-card-body { display: none; } /* Hide headers */
  .ant-table-scroll > .ant-table-body > table > tbody > tr {
    width: 95vw;
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    // gap: 0.2rem;
    padding-bottom: 10px !important;
    background-color:#f5f5f5;
    // border: 1px solid #ccc !important;
    // padding: 0.5rem;
    grid-template-areas: 
      "checkbox pedido pedido pedido cotacao cotacao cotacao acoes"
      "loja loja loja loja status status status status"
      "condicao condicao condicao condicao valor valor valor valor"
      "fornecedor fornecedor fornecedor fornecedor vendedor vendedor vendedor vendedor"
      "data-confirmacao data-confirmacao data-confirmacao data-confirmacao data-entrega data-entrega data-entrega data-entrega";
  }
  // .ant-layout-sider{
  //   width: 1vw;
  //   display: none;
  // }
  .body{
    padding-left: 0px !important;
    // width: 97vw !important;
  }
  td:has(.col-pedido) { grid-area: pedido; }
  td:has(.col-cotacao) { grid-area: cotacao; }
  td:has(.col-loja) { grid-area: loja; }
  td:has(.col-fornecedor) { grid-area: fornecedor; }
  td:has(.col-vendedor) { grid-area: vendedor; }
  td:has(.col-condicao) { grid-area: condicao; }
  td:has(.col-valor) { grid-area: valor; }
  td:has(.col-balance) { grid-area: economia; display:none !important}
  td:has(.col-status) { grid-area: status; }
  td:has(.col-erp) { grid-area: erp; display:none !important}
  td:has(.col-data-pedido) { grid-area: data-pedido; display: none !important; }
  td:has(.col-data-confirmacao) { grid-area: data-confirmacao; }
  td:has(.col-data-entrega) { grid-area: data-entrega }
  td:has(.col-data-recebimento) { grid-area: data-recebimento;  display: none !important; }
  td:has(.col-avaliacao) { grid-area: avaliacao; display: none !important;}
  .col-avaliacao { display: none;}
  td:has(.col-acoes) { grid-area: acoes; align-items: center; vertical-align: center; }
  .ant-table-selection-column { grid-area: checkbox; text-align: center !important; }

  div:has(.order-page-container) .ant-layout-content{
    overflow: hidden;
  }

  .table-container{
    overflow-x: hidden;
    max-height: calc(86vh - 74px) !important;
  }

  .ant-card-extra {
    display: flex;
    gap: 5px;
    flex-direction: column;
  }
  .ant-table-scroll > .ant-table-body > table > tbody > tr > td {
    // display: flex !important;
    flex-direction: column;
    text-align: left;
    padding: 0.3rem !important;
  }

  .ant-table-tbody > tr > td > *::before {
    content: attr(data-label);
    font-weight: bold;
    font-size: 0.8rem;
    text-align: left;
    white-space: nowrap;
    word-break: keep-all;
    text-overflow: ellipsis;
    overflow: visible;

  }

  .ant-table-tbody td [data-label] {
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    font-size: 0.8rem !important;
    font-weight: 300 !important;
    text-align: left;
    justify-content: start !important;
    word-break: normal;
    white-space: collapse;
    text-overflow: ellipsis;
    overflow: visible !important;
  }
  td {
    background-color: #ffffff !important;
  }

  td > div {
    gap: 0.4rem;
  }

  .ant-table-tbody > tr:nth-child(even) > td,
  .ant-table-fixed-left .ant-table-tbody > tr:nth-child(even) > td,
  .ant-table-fixed-right .ant-table-tbody > tr:nth-child(even) > td {
    background-color: #ffffff;

  }

  .ant-table-scroll > .ant-table-body {
    overflow: hidden !important
  }
  
  .ant-table-pagination.ant-pagination {
    float: none !important;
    text-align: center;
    margin: 10 0 !important;
    padding: 0 !important;
  }
  .ant-pagination-total-text{
    width: 100vw;
  }

  .page-body-x {
    margin-left: 0;
  }

  .order-page-container {
    font-size: 1rem;
    padding-right: 0;
  }

}
@media only screen and (max-width: 720px) {
  .page-body-y {
    margin-top: 0 !important;
    min-height: 100vh;
  }
  .order-page-filter-container {
    flex-direction: column;
  }
  .desktop {
    display: none !important;
  }
  .tablet {
    display: block;
  }
  .order-page-filter-section1 {
    margin-bottom: 2vh;
  }
  .order-page-container {
    font-size: 1.25vw;
  }
  .order-page-filter-section1 {
    margin-bottom: 0;
  }

  .tablet {
    display: none;
  }
  .mobile {
    display: block;
  }
  .order-page-filter-section2 {
    width: 100%;
    display: flex;
  }
  .page-filters__right-title-wrapper {
    margin-top: 1vh;
  }
  .order-page-filter-section1 {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .mobile-table-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .mobile-expand-icon {
    font-size: 1.5em;
    color: var(--primary-color);
  }
  .order-page-info-containear {
    flex-direction: column;
    align-items: flex-start;
  }
  .order-page-print-button {
    width: 40%;
    margin-top: 2vh;
  }
  .order-page-container {
    font-size: 2vw;
    height: 100vh;
  }
  .order-page-table-header {
    display: none;
  }
  .order-page-table {
    flex-direction: column;
    gap: 1vh;
    margin-bottom: 3vh;
    font-size: 1.5em;
  }
  .order-page-table-separator {
    border-right: none;
    width: 100%;
    flex: unset;
    display: flex;
    justify-content: space-between;
    padding-right: 3vw;
  }
  .order-table-mobile-header {
    display: flex;
    font-weight: 700;
    font-size: 1.1em;
    text-align: inherit;
  }
  .hide-mobile-filters {
    display: none;
  }
  .order-table-seller-content {
    text-align: end;
  }
  .order-table td,
  .order-table th {
    z-index: 1;
  }
  .actions-width {
    position: sticky;
    right: 0;    
    z-index: 5;
    background: #fff;

  }
  .white-bg{
    background: #fff;
  }
  .checkbox-width {
    color: unset;
    justify-content: flex-start;
    gap: 3vw;
    font-size: 1.1em;
    align-items: center;
  }
  .mobile-id-row {
    display: flex;
    align-items: center;
    gap: 1.5vw;
  }
  .page-filters__right-wrapper {
    width: 100%;
  }
  .mobile-filter-button {
    display: flex;
  }
  .mobile-buttons-row {
    display: flex;
    gap: 10%;
    margin-top: 2vh;
    width: 100%;
    justify-content: space-between;
  }
}
@media only screen and (max-width: 500px) {
    .order-page-container {
        font-size: 3vw;
    }
}
@media only screen and (max-width: 200px) {
    .order-page-container {
        font-size: 3.25vw;
    }
}
</style>
